module.exports = __webpack_public_path__ + "static/Principal-Black-725048162b74b90fe864fdd9d121ffd8.eot";